import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'gender'
})
export class GenderPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    switch (value) {
      case 'F':
        return 'Femenino'
      case 'M':
        return 'Masculino'
    }

    return null
  }
}
